// @ts-ignore
import polygonPolygon from 'intersects/polygon-polygon';
// @ts-ignore
import polygonPoint from 'intersects/polygon-point';

export function checkWarehouseIntersection(polygon: number[][], restrictedAreas: number[][][]) {
  for (const area of restrictedAreas) {
    if (polygonPolygon(polygon.flat(), area.flat())) return true;
  }

  return false;
}

export function checkWarehouseIntersectionByPoint(points: number[], restrictedAreas: number[][][]) {
  for (const area of restrictedAreas) {
    if (polygonPoint(area.flat(), points[0], points[1], 1e-6)) return true; // 10^-6
  }

  return false;
}
